

const Links = () => {
    
    // Listen to anchors links click
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
    
        const targetId = this.getAttribute('href');
        const targetElement = document.querySelector(targetId);
        const header = document.getElementById('main-header');
        const adminBar = document.getElementById('wpadminbar');
        let headerHeight = header.offsetHeight;
        let adminBarHeight = (adminBar) ? adminBar.offsetHeight : 0;
    
        if (targetElement) {
          
          // If header is active (sticky), its height is remove from the top of the page
          if(!header.classList.contains('is-active'))
          {
            headerHeight *= 2;
          }

          const safetyYGap = 20; // gap in px
          const targetTop = targetElement.getBoundingClientRect().top;
          const targetPosition = targetTop + window.scrollY - adminBarHeight - headerHeight - safetyYGap;
    
          // Start smooth scroll
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
}
export default Links;